/* eslint-disable max-len */
import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import SVGIcon from '../../../assets/images/svg/SVGIcon';
import { useDispatch, useSelector } from 'react-redux';
import {
  Btns,
  Icon,
  Icons,
  Modalhead,
  Modalheadleft,
  Textfied,
  Inputs,
  Detail,
  DescriptionSection,
  OverLayDiv,
  Textarea,
  Headtitle,
  ButtonDiv,
  AttachFile,
  Uploaddiv,
  DocumentIcon,
  TaskTitle
} from './style';
import AssignBoxV2 from '../../dropdowns/assignPopup/assignPopupV2';
import {
  isEmpty,
  getFloatTimeValue,
  convertBase64ToFile,
  getFirebaseUrlFromFile,
  handleFileUpload,
  isMediaRecordingSupported
} from '../../../helpers/common';
import Button from '../../button';
import UserPreferenceSingleton from '../../../helpers/userPreferenceSingleton';
import { COMMENT_TYPE, FILE_TYPES, TASK_PRIORITY } from '../../../global/constants';
import { useHistory, useParams } from 'react-router-dom';
import {
  createNewComment,
  createNewTask,
  getTaskGroupList,
  updateIndexDbProjectTasks,
  updateRecurringTaskDetails,
  updateTaskDetails
} from '../../../services/taskServices';
import ModalCustom from '../modal';
import DeleteModal from '../deleteModel';
import { trackAnalyticActivity } from '../../../services/analyticsService';
import { dispatchProjectError, getMilestoneList, getProjectFiles } from '../../../services/projectServices';
import { captureException } from '../../../services/logService';
import { RootReducerInterface } from '../../../interfaces/RootReducerInterface';
import { StatusListInterface } from '../../../interfaces/ProjectInterface';
import { CommentFilesInterface } from '../../../interfaces/TaskInterface';
import { useMobileDevice } from '../../../global/useMobile';
import DescriptionInputBox from '../../inputBox/descriptionInputBox';
import { TASK_ANALYTICS } from '../../../global/analyticsConstants';
import SnapRecordModal from '../snapRecordModal';
import { Dropdown, DropdownItem } from '../../Dropdown';
import CommentDropdown from '../../dropdowns/commentDropdown/commentdropdown';
import Drawer from '../../customDrawer/customDrawer';
import { rootStore } from '../../../mobx/rootStore';
import TaskStatusDropdownV2 from '../../dropdowns/taskStatusDropdown/taskStatusDropdownV2';
import PriorityDropdownV2 from '../../dropdowns/priorityDropdown/priorityDropdownV2';
import LabelDropdownV2 from '../../dropdowns/labeldropdown/labelDropdownMenuV2';
import EstimateDropdownV2 from '../../dropdowns/estimatedropdown/estimateDropdownV2';
import GroupDropdown from '../../dropdowns/statusDropdown/groupDropdown';
import { TaskModel } from '../../../mobx/models/task';
import RenderProjectListV2 from './renderProjectListV2';
import { observer } from 'mobx-react-lite';
import CalendarPopUpV2 from '../../calendarPopUp/calendarPopUpV2';
import { syncTasks } from '../../../services/syncService';
import RenderExistingFileV2 from '../../renderExistingFile/renderExistingFileV2';
import { getTaskTemplateList } from '../../../services/settingServices';
type DropdownPlacementType =
  | 'bottomLeft'
  | 'bottom'
  | 'topLeft'
  | 'topCenter'
  | 'topRight'
  | 'bottomCenter'
  | 'bottomRight'
  | 'top';
interface Props {
  onCancel?: Function;
  loadData?: () => void;
  isFromShortcut?: boolean;
  isFromMyTask?: boolean;
  isTaskDetail?: boolean;
  onProjectChange?: (value: boolean) => void;
  isTemplateProject?: boolean;
  isFromSubList?: boolean;
  DropdownPlacement?: DropdownPlacementType;
  isRecurringTask?: boolean;
  data?: TaskModel;
  isTaskDetailPreview?: boolean;
}

interface LinkObject {
  href: string;
  name: string;
}
const CreateTaskModalV2: React.FC<Props> = (props) => {
  const {
    loadData,
    onCancel,
    isFromShortcut = false,
    isTaskDetail,
    isFromMyTask = false,
    onProjectChange,
    isTemplateProject = false,
    isFromSubList = false,
    isRecurringTask,
    data,
    isTaskDetailPreview
  } = props;
  //Refs
  const fileInputRef = useRef<HTMLInputElement>(null);
  const inlineRef = useRef<any>(null);
  //States
  const [loading, setLoading] = useState(false);
  const params: { id: string } = useParams();
  const [isEstimateDropdownOpen, setIsEstimateDropdownOpen] = useState(false);
  const [isAssignDropdownOpen, setIsAssignDropdownOpen] = useState(false);
  const [closeModel, setCloseModel] = useState(false);
  const history = useHistory();
  const [fileUploading, setFileUploading] = useState(false);
  const [selectFile, setSelectFile] = useState<boolean>(false);
  const [attachment, setAttachment] = useState(false);
  const [isSnapModalOpen, setIsSnapModalOpen] = useState(false);
  // Add a state to force re-render when labels change
  const [labelsVersion, setLabelsVersion] = useState(0);
  const [priorityVersion, setPriorityVersion] = useState(0);

  //use selector state variables
  const stateSelector = useSelector((state: RootReducerInterface) => state);
  const { settings: settingsSelector, project: projectSelector } = stateSelector || {};
  const { uploadFilePercent } = projectSelector;
  const { projectTemplateDetails, taskTemplateList } = settingsSelector;
  //Mobx store variables
  const { taskStore, workspaceStore, projectStore } = rootStore;
  const { createTaskInput } = taskStore;
  const { project } = createTaskInput;
  const { currentWorkspace: workspace } = workspaceStore;
  const { currentProject } = projectStore;
  //Other variable
  const dispatch = useDispatch();
  const mobile = useMobileDevice();

  // Add an effect to observe changes to labels
  useEffect(() => {
    // This will force a re-render when labels change
    setLabelsVersion((prev) => prev + 1);
  }, [createTaskInput?.labelsIds]);

  useEffect(() => {
    setPriorityVersion((prev) => prev + 1);
  }, [createTaskInput?.priority]);

  const loadProjectData = useCallback(async () => {
    try {
      if (createTaskInput?.project?.id) {
        const promises = [];
        if (createTaskInput?.project?.isGroupEnabled && isEmpty(project?.taskGroups)) {
          promises.push(dispatch(getTaskGroupList(createTaskInput?.project?.id)));
        }
        if (createTaskInput?.project?.isMilestone && isEmpty(project?.milestones)) {
          promises.push(dispatch(getMilestoneList(createTaskInput?.project?.id)));
        }
        promises.push(dispatch(getProjectFiles(createTaskInput?.project?.id)));
        promises.push(dispatch(getTaskTemplateList()));
        await Promise.all(promises);
      }
    } catch (error) {
      console.log('error', error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createTaskInput?.project?.id, dispatch]);

  useEffect(() => {
    loadProjectData();
  }, [loadProjectData]);

  const clearData = useCallback(() => {
    if (!isEmpty(createTaskInput?.name) || !isEmpty(createTaskInput?.description) || !isEmpty(createTaskInput.files)) {
      setCloseModel(true);
    } else {
      taskStore.createTaskInput.clear();
      if (onCancel) onCancel();
    }
  }, [createTaskInput?.name, createTaskInput?.description, createTaskInput.files, taskStore.createTaskInput, onCancel]);

  const close = useCallback(() => {
    setCloseModel(false);
    taskStore.createTaskInput.setLabels([]);
  }, [taskStore.createTaskInput]);

  const onOnkDeleteModel = useCallback(() => {
    setCloseModel(false);
    taskStore.createTaskInput.clear();
    if (onCancel) onCancel();
  }, [onCancel, taskStore.createTaskInput]);

  const extractLinkObject = useCallback(async (htmlSnippet: string) => {
    const tempElement = document.createElement('div');
    tempElement.innerHTML = htmlSnippet;
    const linkElement = tempElement.querySelectorAll('a');
    const content = tempElement.querySelector('p');
    const extractedLinks: LinkObject[] = [];

    linkElement.forEach((linkElement) => {
      const href = linkElement.getAttribute('href');
      const name = linkElement.textContent?.trim() || '';

      extractedLinks.push({
        href: href || '',
        name: name.replace(/\s+/g, '-')
      });
    });
    return { content, extractedLinks };
  }, []);

  const loadFileData = useCallback(async () => {
    if (!isEmpty(createTaskInput?.id) && (!isEmpty(createTaskInput?.description) || !isEmpty(createTaskInput?.files))) {
      const fileName = createTaskInput?.description;
      if (fileName) extractLinkObject(fileName);
    }
  }, [createTaskInput, extractLinkObject]);

  useEffect(() => {
    loadFileData();
  }, [loadFileData]);

  const onCreateTask = useCallback(
    async (e: React.SyntheticEvent) => {
      e.preventDefault();
      if (isEmpty(createTaskInput?.name)) {
        dispatchProjectError('Please add title for task');
        return;
      }
      if (isEmpty(createTaskInput?.project?.id)) {
        dispatchProjectError('Please select a project for the task at the top of the modal.');
        return;
      }
      try {
        setLoading(true);
        const userDetails = UserPreferenceSingleton.getInstance().getCurrentUser();
        const uploadedFiles: CommentFilesInterface[] = createTaskInput?.files || [];
        let descriptionData = createTaskInput?.description || '';
        const pattern = /(^<p><br><\/p>\s*)|(<p><br><\/p>\s*$)/;
        if (!isEmpty(descriptionData)) {
          while (pattern.test(descriptionData)) {
            descriptionData = descriptionData.replace(pattern, '');
          }
          if (descriptionData.match(/<br\s*>\s*<\/p>$/))
            descriptionData = descriptionData.replace(/<br\s*>\s*<\/p>$/, '</p>');
        }
        const tempElement = document.createElement('div');
        tempElement.innerHTML = descriptionData || '';
        const linkElements = tempElement.querySelectorAll('img');
        let promises: Promise<void>[] = [];
        linkElements.forEach((linkElement) => {
          // Create a promise for each linkElement
          const myPromise = (async function () {
            const srclink = linkElement?.getAttribute('src');
            if (srclink && !isEmpty(srclink)) {
              if (
                !srclink?.startsWith('https://firebasestorage') &&
                !srclink?.startsWith('https://figma') &&
                !srclink?.startsWith('/static') &&
                !srclink?.startsWith('https://')
              ) {
                try {
                  const fileData = await convertBase64ToFile(srclink);
                  const fileUrl = await getFirebaseUrlFromFile({ file: fileData }, 'files/', dispatch);
                  if (fileUrl) {
                    descriptionData = descriptionData?.replace(srclink, fileUrl);
                  }
                } catch (error) {
                  console.error('Error processing image URL', error);
                }
              }
            }
          })();
          promises.push(myPromise);
        });

        await Promise.all(promises);

        let response;

        // Handle task update
        if (!isEmpty(createTaskInput?.id)) {
          let taskDesc = isEmpty(createTaskInput?.description) ? descriptionData || '' : descriptionData;

          // Process task users and subscribers
          let subscribersClone = JSON.parse(JSON.stringify(createTaskInput?.subscribers));
          const taskUsers = createTaskInput?.users
            ?.map((item) => {
              // const userFromData = taskInput?.users?.find((x) => item?.id === x.id);
              if (isEmpty(item)) {
                subscribersClone?.push(item?.id);
                return {
                  _id: item?.id,
                  CreatedBy: userDetails?.id,
                  CreatedTime: new Date().toISOString(),
                  UpdatedBy: userDetails?.id,
                  UpdatedTime: new Date().toISOString()
                };
              }
              return item;
            })
            .filter((user) => user !== undefined);

          // Format files for update
          const updatedFiles = createTaskInput?.files?.map((file) => ({
            fileType: file?.file_type,
            name: file?.name,
            href: file?.href,
            size: file?.size,
            uploadFileType: file?.uploadFileType
          }));

          taskStore.createTaskInput.setDescription(descriptionData);
          const labelIdList = createTaskInput?.labels?.map((item: { id: string }) => item?.id);

          // Prepare update payload
          const payloadTask = {
            projectId: project?.id,
            name: createTaskInput?.name,
            description: taskDesc || '',
            dueDate: createTaskInput?.dueDate,
            dueDateUnset: isEmpty(createTaskInput?.dueDate) ? true : null,
            taskUsers: taskUsers?.map((x: any) => x.id),
            groupId: project?.isGroupEnabled && !isEmpty(createTaskInput?.groupId) ? createTaskInput?.groupId : null,
            estimateTime:
              typeof createTaskInput?.estimate === 'number'
                ? createTaskInput?.estimate
                : getFloatTimeValue(createTaskInput?.estimate || ''),
            priority: currentProject?.priority?.enabled ? createTaskInput?.priority : null,
            files: !isEmpty(createTaskInput?.files) ? updatedFiles : [],
            milestoneId: !isEmpty(createTaskInput?.milestone?.id) ? createTaskInput?.milestone?.id : undefined,
            milestoneIdUnset: isEmpty(createTaskInput?.milestone?.id) ? true : null,
            labels: labelIdList,
            statusId: project?.statusEnable ? createTaskInput?.statusId || project?.defaultStatus?.['_id'] : null
          };

          // Update task
          if (isRecurringTask) {
            response = await dispatch(updateRecurringTaskDetails(createTaskInput?.id, payloadTask));
          } else {
            response = await dispatch(updateTaskDetails(createTaskInput?.id, payloadTask));
            await dispatch(
              createNewComment(createTaskInput?.id, {
                Type: COMMENT_TYPE.UPDATE_TASK
              })
            );
          }
          trackAnalyticActivity(TASK_ANALYTICS.UPDATED);
          // Handle new task creation
        } else {
          taskStore.createTaskInput.setDescription(descriptionData);
          const labelIdList = createTaskInput?.labels?.map((item) => item?.id);
          const taskUsers = createTaskInput?.users?.map((item) => item?.id);

          // Format files for new task
          const updatedFileName = uploadedFiles?.map((item) => ({
            name: item?.name,
            href: item?.href,
            size: item?.size,
            fileType: item?.file_type,
            uploadFileType: item?.uploadFileType
          }));

          // Prepare create payload
          const payload: any = {
            name: createTaskInput?.name,
            projectId: createTaskInput?.project?.id,
            groupId: project?.isGroupEnabled ? createTaskInput?.groupId : null,
            dueDate: createTaskInput?.dueDate,
            description: descriptionData,
            status: false,
            taskUsers: taskUsers,
            estimateTime:
              typeof createTaskInput?.estimate === 'number'
                ? createTaskInput?.estimate
                : getFloatTimeValue(createTaskInput?.estimate || ''),
            priority: currentProject?.priority?.enabled ? createTaskInput?.priority : null,
            files: !isEmpty(uploadedFiles) ? updatedFileName : [],
            milestoneId: !isEmpty(createTaskInput?.milestone?.id) ? createTaskInput?.milestone?.id : null,
            labels: labelIdList || [],
            parentTaskId: !isEmpty(createTaskInput?.parentTaskId) ? createTaskInput?.parentTaskId : null,
            statusId: project?.statusEnable ? createTaskInput?.statusId ?? project?.defaultStatus?.['_id'] : undefined
          };

          if (createTaskInput?.recurringInterval) {
            payload.recurringInterval = createTaskInput.recurringInterval?.toLowerCase();
            payload.start = createTaskInput.start?.toLowerCase();
          }
          response = await dispatch(createNewTask(payload));

          // Track analytics
          const eventProperties = {
            source: isFromShortcut ? 'shourtcut' : isFromMyTask ? 'my task' : 'task list'
          };
          trackAnalyticActivity(TASK_ANALYTICS.CREATED, eventProperties);
        }

        // Handle successful response
        if (response) {
          await syncTasks({ loadCached: false });

          // Handle navigation after task creation/update
          if (createTaskInput?.id && isTaskDetail && !isFromSubList) {
            rootStore.taskStore.setCurrentTask(createTaskInput?.id);
            history.push(`/projects/details/${project?.id}/tasks?task=${createTaskInput?.id}`);
          }

          if (onCancel) onCancel();

          // Update IndexDB if project changed
          if (createTaskInput?.project?.id !== params?.id) {
            const newProjectId = createTaskInput?.project?.id;
            await dispatch(updateIndexDbProjectTasks(newProjectId, workspace?.id));
          }

          // Handle project change callbacks
          if (onProjectChange && project?.id !== params?.id && isTaskDetail && !isTaskDetailPreview) {
            onProjectChange(true);
          } else if (loadData) {
            loadData();
          }
        }
      } catch (e) {
        captureException(e);
        console.log('ERROR', e);
      } finally {
        taskStore.createTaskInput.clear();
        setLoading(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      createTaskInput,
      dispatch,
      taskStore.createTaskInput,
      createTaskInput?.dueDate,
      project?.id,
      project?.isGroupEnabled,
      project?.statusEnable,
      project?.defaultStatus,
      currentProject?.priority?.enabled,
      isRecurringTask,
      isFromShortcut,
      isFromMyTask,
      isTaskDetail,
      isFromSubList,
      onCancel,
      params?.id,
      onProjectChange,
      isTaskDetailPreview,
      history,
      workspace?.id,
      loadData
    ]
  );

  const onUpdateStatus = useCallback(async (status: StatusListInterface, previousStatus: StatusListInterface) => {
    if (status['_id'] !== previousStatus['_id']) {
      rootStore.taskStore.createTaskInput.setStatusId(status['_id']);
    }
  }, []);

  const handleFileInput = useCallback(() => {
    queueMicrotask(() => {
      if (fileInputRef.current) {
        fileInputRef.current.click();
      }
    });
  }, []);

  const onFileUpload = useCallback(
    async (event: React.ChangeEvent<HTMLInputElement>) => {
      const { files } = event.target;
      if (!files || files.length === 0) {
        dispatchProjectError('No files selected.');
        return;
      }

      try {
        setFileUploading(true);
        const fileArray = Array.from(files); // Convert FileList to Array
        //call common function to upload file in firebase
        const updatedFiles = await handleFileUpload(createTaskInput?.files || [], fileArray, dispatch, inlineRef);
        const value = [...(createTaskInput?.files || []), ...(updatedFiles || [])];
        createTaskInput?.setFiles(value);
        // setUpdatedFile(value);
      } catch (error) {
        captureException(error);
        dispatchProjectError('Error occurred while uploading files.');
      } finally {
        setFileUploading(false);
      }
    },
    [createTaskInput, dispatch]
  );

  const onSelectFile = useCallback(
    (item: any) => {
      const parts = item?.name?.split('.');
      const extension = parts[parts.length - 1];
      let fileUrl;
      if (item?.uploadFileType === FILE_TYPES.DOCS || item?.uploadFileType === FILE_TYPES.WHITEBOARD) {
        if (!isEmpty(item?.parentId) && !isEmpty(item?.id)) {
          fileUrl = `/projects/files/${params?.id}/docs/${item?.id}?folder=${item?.parentId}`;
        } else if (!isEmpty(item?.id) && isEmpty(item?.parentId)) {
          fileUrl = `/projects/files/${params?.id}/docs/${item?.id}`;
        }
      } else {
        fileUrl = item?.url;
      }
      const sizeInMB = item?.size / (1024 * 1024);
      let sizeValue;
      if (sizeInMB >= 1) {
        sizeValue = `${sizeInMB.toFixed(2)} MB`;
      } else {
        const sizeInKB = item?.size / 1024;
        sizeValue = `${sizeInKB.toFixed(2)} KB`;
      }
      if (extension === 'png' || extension === 'jpeg' || extension === 'jpg') {
        inlineRef.current.addImageInContent(fileUrl);
      } else if (extension === 'mp4' || extension === 'mov' || extension === 'mkv' || extension === 'webm') {
        inlineRef.current.addRecordingCard(fileUrl, item?.name);
      } else {
        const newObj: CommentFilesInterface = {
          name: item?.name,
          href: fileUrl || '',
          size: sizeValue,
          file_type:
            item?.uploadFileType === FILE_TYPES.DOCS
              ? 'docs'
              : item?.uploadFileType === FILE_TYPES.WHITEBOARD
              ? 'white'
              : extension,
          isCreatedDoc: true,
          uploadFileType: Number(item?.uploadFileType)
        };
        taskStore.createTaskInput.setFiles([...(createTaskInput?.files || []), newObj]);
      }
    },
    [createTaskInput?.files, params?.id, taskStore.createTaskInput]
  );

  const attachmentPage = useCallback(() => {
    if (!project?.name) {
      dispatchProjectError('Please select the project');
      return;
    }
    currentProject?.setCurrentFolderId(null);
    if (mobile) {
      setSelectFile(true);
    } else {
      setAttachment(true);
    }
  }, [project?.name, currentProject, mobile]);

  const handleOpenSnapModal = useCallback(() => {
    setIsSnapModalOpen(true);
  }, []);

  const handleCloseSnapModal = useCallback(() => {
    setIsSnapModalOpen(false);
  }, []);

  // render milestone data
  const renderMilestoneData = useMemo(() => {
    return project?.milestones?.map((mileStone) => (
      <DropdownItem
        key={mileStone?.id}
        label={mileStone?.milestoneName}
        onClick={() => {
          if (createTaskInput?.milestone?.id === mileStone?.id) {
            taskStore.createTaskInput.setMilestone(null);
          } else {
            taskStore.createTaskInput.setMilestone(mileStone?.id);
          }
        }}></DropdownItem>
    ));
  }, [createTaskInput?.milestone?.id, project?.milestones, taskStore.createTaskInput]);

  if (selectFile) {
    return (
      <RenderExistingFileV2
        setAttachment={() => setAttachment(false)}
        setSelectFile={(value: boolean) => setSelectFile(value)}
        isCreateTaskModal={true}
        onSelectFile={onSelectFile}
      />
    );
  }

  const onClose = () => {
    setAttachment(false);
  };

  const templateData = taskTemplateList.map((template) => ({
    key: template['_id'] || '',
    label: template.Title || 'undefined'
  }));

  const handleDocumentIconClick = (templateId: string | number | undefined) => {
    if (isEmpty(createTaskInput?.project?.id)) {
      dispatchProjectError('Please select a project for the task at the top of the modal.');
      return;
    }
    const selectedTemplate = taskTemplateList.find((template) => template['_id'] === templateId);
    selectedTemplate?.Assignee?.forEach((item) => {
      rootStore.taskStore.createTaskInput.addAssignee(item);
    });
    rootStore.taskStore.createTaskInput.setPriority(selectedTemplate?.Priority || TASK_PRIORITY.NO_PRIORITY);
    rootStore.taskStore.createTaskInput.setDescription(selectedTemplate?.Description || '');
    rootStore.taskStore.createTaskInput.setName(selectedTemplate?.Title || '');
    rootStore.taskStore.createTaskInput.setFiles(selectedTemplate?.Files || []);
  };

  return (
    <>
      <Modalhead>
        <Modalheadleft>
          <RenderProjectListV2 isFromMyTask />
          {project?.isMilestone && project?.milestones?.length > 0 && (
            <>
              <SVGIcon name='dot-icon' viewBox='0 0 15 15' width='15' height='15' className='dot-icon' />
              <Dropdown
                modalTitle='Milestone'
                content={
                  <Headtitle>
                    {!isEmpty(createTaskInput?.milestoneId)
                      ? createTaskInput?.milestone?.milestoneName
                      : 'Select Milestone'}
                  </Headtitle>
                }
                trigger='click'>
                {renderMilestoneData}
              </Dropdown>
            </>
          )}
        </Modalheadleft>
        <Icon onClick={clearData}>
          <SVGIcon name='close-icon' width='18' height='18' viewBox='0 0 18 18' fill='none' className='svgicon' />
        </Icon>
      </Modalhead>
      <Inputs>
        <Textfied>
          <TaskTitle
            className='taskarea'
            placeholder='Task Title'
            autoFocus={true}
            value={createTaskInput?.name}
            onChange={(e) => {
              taskStore.createTaskInput.setName(e.target.value);
              e.target.style.height = '25px'; // Reset the height
              e.target.style.height = `${e.target.scrollHeight}px`; // Set the height to the scroll height
            }}
          />
        </Textfied>
        <Textarea>
          <DescriptionSection>
            <DescriptionInputBox
              ref={inlineRef}
              valueContent={createTaskInput?.description!}
              setValueContent={(value: string) => taskStore.createTaskInput.setDescription(value)}
              uploadedFiles={createTaskInput?.files || []}
              setUploadedFiles={(value: any) => createTaskInput.setFiles(value)} //Set uploaded file changes
              setPropsLoading={(value: boolean) => setLoading(value)}
              setStateLoading={(value: boolean) => setFileUploading(value)}
              handleOpenSnapModal={handleOpenSnapModal}
              handleFileInput={handleFileInput}
            />
          </DescriptionSection>
        </Textarea>
      </Inputs>
      {fileUploading && <Uploaddiv>Uploading ({Math.floor(uploadFilePercent)}%)</Uploaddiv>}
      <Btns>
        <Icons>
          {(isTemplateProject
            ? projectTemplateDetails?.statusEnable && projectTemplateDetails?.statusData?.length > 0
            : project?.statusEnable && project?.statusData?.length > 0) && (
            <TaskStatusDropdownV2
              defaultStatus={project?.defaultStatus}
              statusList={project?.statusData || []}
              currentStatusId={createTaskInput?.statusId}
              isCreateTask={true}
              onUpdateStatus={(status, previousStatus) => onUpdateStatus(status, previousStatus)}
            />
          )}
          <Detail>
            <AssignBoxV2
              setIsDropdownOpen={setIsAssignDropdownOpen}
              isHumanIcon={true}
              projectUsers={project?.users || []}
              isCreateTaskModal={true}
              isMultiAssignee={createTaskInput?.project?.multiAssignee || createTaskInput?.project?.multiAssignee}
            />
          </Detail>
          {!isTemplateProject && (
            <Detail>
              <CalendarPopUpV2
                isCreateTask={true}
                loadData={loadData}
                isRecurringTask={isRecurringTask}
                isHideText={true}
                data={data}></CalendarPopUpV2>
            </Detail>
          )}
          {project?.isGroupEnabled && project.taskGroups && project.taskGroups?.length > 0 && (
            <Detail>
              <GroupDropdown isCreateTaskModal currentProject={project} value={createTaskInput?.groupId} />
            </Detail>
          )}
          {project?.isEstimate && (
            <Detail>
              <EstimateDropdownV2 isCreateTask={true} />
            </Detail>
          )}

          {project?.priority?.enabled && (
            <Detail>
              <PriorityDropdownV2
                key={`priority-dropdown-${priorityVersion}`}
                currentProject={project}
                isCreateTask={true}
              />
            </Detail>
          )}

          {project?.labelsEnabled && (
            <LabelDropdownV2 key={`label-dropdown-${labelsVersion}`} currentProject={project} isCreateTask={true} />
          )}
        </Icons>

        <ButtonDiv>
          <input type='file' ref={fileInputRef} style={{ display: 'none' }} onChange={onFileUpload} multiple />
          <div style={{ display: 'flex', gap: 4 }}>
            {!createTaskInput?.id && taskTemplateList?.length > 0 && (
              <Dropdown
                modalTitle='Template'
                content={
                  <DocumentIcon>
                    <SVGIcon
                      name='document-icon'
                      width='16'
                      height='16'
                      viewBox='0 0 18 18'
                      className='template-doc-icon'
                    />
                  </DocumentIcon>
                }
                trigger='click'>
                {templateData.map((item) => (
                  <DropdownItem
                    key={item.key}
                    label={item.label}
                    onClick={(key) => handleDocumentIconClick(item.key)}
                  />
                ))}
              </Dropdown>
            )}
            <Dropdown
              modalTitle='Attachment'
              activeClassName='active'
              content={
                <AttachFile>
                  <SVGIcon name='attachment-icon' width='16' height='16' viewBox='0 0 18 18' className='svg' />
                </AttachFile>
              }
              trigger='click'>
              <CommentDropdown onClickUploadFile={handleFileInput} onClickSelectFile={attachmentPage} />
            </Dropdown>
          </div>
          <Button
            onClick={onCreateTask}
            title={createTaskInput?.id ? 'Update Task' : 'Create Task'}
            isLoading={loading || fileUploading}
            size={'small'}
          />
          {/* select file drawer */}
          <Drawer
            placement='right'
            onClose={onClose}
            open={attachment}
            width='350px'
            bodyStyle={{ padding: 0, scrollbarWidth: 'none' }}>
            <RenderExistingFileV2
              setAttachment={() => setAttachment(false)}
              isCreateTaskModal
              onSelectFile={onSelectFile}
            />
          </Drawer>
        </ButtonDiv>
      </Btns>
      {isEstimateDropdownOpen && (
        <OverLayDiv className='dropdown-overlay' onClick={() => setIsEstimateDropdownOpen(false)} />
      )}

      <ModalCustom open={closeModel} onClose={close} width={334}>
        <DeleteModal
          isYes={true}
          onClose={close}
          onOk={onOnkDeleteModel}
          modalTitle='Confirmation Model'
          description='Are you sure you want close this model?'
        />
      </ModalCustom>
      {isAssignDropdownOpen && (
        <OverLayDiv
          className='dropdown-overlay'
          onClick={() => {
            setIsAssignDropdownOpen(false);
          }}
        />
      )}
      {isMediaRecordingSupported() && (
        <ModalCustom open={isSnapModalOpen} onClose={handleCloseSnapModal} width={258}>
          <SnapRecordModal handleCloseModal={handleCloseSnapModal} />
        </ModalCustom>
      )}
    </>
  );
};

export default observer(CreateTaskModalV2);
